module.exports = new __parcel__URL__("mastercard.670114e0.svg").toString();